var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vSelect',{attrs:{"options":_vm.lineOptions,"reduce":label => label.code,"label":"label"},model:{value:(_vm.line),callback:function ($$v) {_vm.line=$$v},expression:"line"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }